import React from 'react';

import { SelectionSetting, SelectionSettingProps } from '@lumapps/designer-widget-settings/components/SelectionSetting';
import { SelectionSettingType } from '@lumapps/designer-widget-settings/types';
import { EventPickerDialog } from '@lumapps/event-pickers/components/EventPickerDialog';
import { EventPickerDialogProps } from '@lumapps/event-pickers/types';
import { getEvents } from '@lumapps/events/api/getEvents';
import { EVENTS } from '@lumapps/events/keys';
import { Event } from '@lumapps/events/types';
import { RelativeDate } from '@lumapps/lumx-texts/components/RelativeDate';
import { mdiCalendar } from '@lumapps/lumx/icons';
import { makeSecuredMediaURLRelative } from '@lumapps/medias/utils';

import { DATA_SCOPE } from '../../../constants';

export interface SelectionSectionProps {
    currentSelection?: SelectionSettingType;
    onChange: (properties: { selection: SelectionSettingType }) => void;
}

const CLASSNAME = 'selection-section';

const ENTITY_BLOCK: SelectionSettingProps<Event, EventPickerDialogProps>['entityBlock'] = {
    title: (event) => event.structuredContent.title?.value as string,
    subtitle: (event) => <RelativeDate key="date" date={event.createdAt} />,
    icon: mdiCalendar,
    image: (event) => makeSecuredMediaURLRelative(event.structuredContent.richText?.value?.featuredImage?.url),
};

export const SelectionSection: React.FC<SelectionSectionProps> = ({
    currentSelection: widgetCurrentSelection,
    onChange,
}) => {
    const handleOnChange = React.useCallback(
        (selection: SelectionSettingType) => {
            onChange({ selection });
        },
        [onChange],
    );

    return (
        <SelectionSetting<Event, EventPickerDialogProps>
            entityBlock={ENTITY_BLOCK}
            entityPicker={{
                component: EventPickerDialog,
                props: { isMultipleSelect: true },
            }}
            manualButtonText={EVENTS.SELECT_EVENTS}
            onChange={handleOnChange}
            getEntities={getEvents}
            currentSelection={widgetCurrentSelection}
            dataScope={`${DATA_SCOPE}-selection`}
            className={CLASSNAME}
        />
    );
};
